export const confirmationModalInitialState = {
	show: false,
	indexToDelete: null,
};

export const confirmationModalReducerActions = {
	OPEN: 0,
	CLOSE: 1,
};

export const confirmationModalReducer = (state, action) => {
	switch (action.type) {
		case confirmationModalReducerActions.OPEN:
			return {
				...state,
				show: true,
				indexToDelete: action.payload,
			};

		case confirmationModalReducerActions.CLOSE:
			return confirmationModalInitialState;

		default:
			throw new Error("Invalid reducer action at confirmationModalReducer");
	}
};
